// Firebase Web SDK configuration for project `sketcher-efbb0`.
//
// Generated from the "Sketcher Host" Web app registration. To regenerate:
//   firebase apps:sdkconfig web --project sketcher-efbb0
//
// These values are NOT secrets. A Firebase web API key identifies the project;
// it authorizes nothing on its own. Access is controlled by Auth custom claims,
// Firestore rules, and the callable guards. Committing it is the documented,
// expected practice — the key ships in the client bundle regardless.

export const firebaseConfig = {
  apiKey:            'AIzaSyBOFW9gDY9QMfZzAv2eG7fKDhA9eBiAuiE',
  authDomain:        'sketcher-efbb0.firebaseapp.com',
  projectId:         'sketcher-efbb0',
  storageBucket:     'sketcher-efbb0.firebasestorage.app',
  messagingSenderId: '384386370424',
  appId:             '1:384386370424:web:d4370274a60038067f568d',
}

/** Cloud Functions region — must match the region the callables deploy to. */
export const FUNCTIONS_REGION = 'us-central1'
